import category from "../../../images/sidebar-icons/Category.svg";
import Work from "../../../images/sidebar-icons/Work.svg";
import AppFeed from "../../../images/sidebar-icons/appFeed.svg";
import settings from "../../../images/sidebar-icons/Setting.svg";
import star from "../../../images/sidebar-icons/Star.svg";

import abhivyakti from "../../../images/sidebar-icons/abhivyakti.svg";
import audience from "../../../images/sidebar-icons/audience.svg";
import master from "../../../images/sidebar-icons/master.svg";
import Setting from "../../../images/sidebar-icons/Setting.svg";

export const MenuList = [
  //Dashboard
  {
    title: "Dashboard",
    module: "dashboard",
    classsChange: "mm-collapse",
    iconStyle: <img src={category} />,
    content: [
      {
        title: "Dashboard",
        to: "dashboard",
      },
    ],
  },

  {
    title: "App Feed",
    module: "appfeed",
    classsChange: "mm-collapse",
    iconStyle: <img src={AppFeed} />,
    content: [
      {
        title: "App Feed",
        to: "app-feed",
      },
    ],
  },

  //Apps
  {
    title: "Projects",
    module: "projects",
    classsChange: "mm-collapse",
    iconStyle: <img src={Work} />,
    content: [
      {
        title: "Projects",
        to: "projects",
      },
    ],
  },

  {
    title: "Artists",
    // update: "New",
    module: "artists",
    classsChange: "mm-collapse",
    iconStyle: <img src={star} />,
    content: [
      {
        title: "Artists",
        to: "artists",
      },
    ],
  },
  {
    title: "Audience",
    // update: "New",
    classsChange: "mm-collapse",
    iconStyle: <img src={audience} />,
    module: "audience",
    content: [
      {
        title: "Audience",
        to: "audience",
      },
    ],
  },
  {
    title: "Organisation",
    // update: "New",
    classsChange: "mm-collapse",
    iconStyle: <img src={settings} />,
    module: "organisation",
    content: [
      {
        title: "UNM Team",
        to: "users",
      },
    ],
  },

  //Charts
  {
    title: "Abhivyakti",
    classsChange: "mm-collapse",
    iconStyle: <img src={abhivyakti} />,
    module: "abhivyakti",
    content: [
      {
        title: "Initiatives",
        // iconStyle: <img src={settings} />,
        to: "initiatives",
      },
      {
        title: "Venues",
        // iconStyle: <img src={settings} />,
        to: "venues",

      },
      {
        title: "Stages",
        // iconStyle: <img src={settings} />,
        to: "show-venues",

      },
      {
        title: "Shows",
        // iconStyle: <img src={settings} />,
        to: "shows",

      },
    ],
  },
  {
    title: "Master",
    module: "master",
    classsChange: "mm-collapse",
    iconStyle: <img src={master} />,
    content: [
      {
        title: "Country",
        // iconStyle: <img src={settings} />,
        to: "countries",
      },
      {
        title: "State",
        // iconStyle: <img src={settings} />,
        to: "states",
      },
      {
        title: "City",
        // iconStyle: <img src={settings} />,
        to: "cities",
      },
      {
        title: "Art Form",
        // iconStyle: <img src={settings} />,
        to: "art-form",
      },
      {
        title: "Genre",
        // iconStyle: <img src={settings} />,
        to: "genre",
      },
      {
        title: "UNM Roles",
        // iconStyle: <img src={settings} />,
        to: "rbac",
      },
    ],
  },
  {
    title: "App Configuration",
    module: "config",
    classsChange: "mm-collapse",
    iconStyle: <img src={AppFeed} />,
    content: [
      {
        title: "Guest Management",
        to: "config/guest-management",
      },
      {
        title: "App Version",
        to: "config/app-version",
      },
      {
        title: "QR Pass",
        to: "config/qr-pass",
      },
      {
        title: "Notification",
        to: "config/notification",
      },
      {
        title: "OnBoarding",
        to: "config/onboarding",
      },
    ],
  },
];
